import { routes as List } from './list/index'
import { routes as New } from './new/index'
import { routes as ShowEmployee } from './show/index'
import { routes as EmployeePaycheck } from './paycheck/index'
import { routes as NewEmployeePaycheck } from './new-paycheck/index'

import { routes as ScaleList } from './scales/index'
export default [
  {
    path: '/usuarios',
    name: 'employees',
    component: () => import('./Users.vue'),
    children: [
      ...List,
      ...New,
      ...ShowEmployee,
      ...EmployeePaycheck,
      ...NewEmployeePaycheck,
      ...ScaleList,
    ],
  },
]
